function mtInit() {
  initRevealAnimations();
  initContadores();
  initGaleriaProducto();
  initVariantesProducto();
  initModalResena();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mtInit);
} else {
  mtInit();
}

/* Revela con IntersectionObserver los elementos .mt-reveal / .mt-reveal-scale */
function initRevealAnimations() {
  const elementos = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
  if (!elementos.length) return;

  const reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducirMovimiento) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const retraso = entry.target.dataset.mtDelay || 0;
          setTimeout(() => entry.target.classList.add('mt-visible'), Number(retraso));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  elementos.forEach((el, index) => {
    if (el.closest('[data-mt-stagger]') && !el.dataset.mtDelay) {
      el.dataset.mtDelay = (index % 6) * 90;
    }
    el.classList.add('mt-armado');
    observer.observe(el);
  });
}

/* Cifras animadas (count-up) para elementos [data-mt-contador][data-hasta] */
function initContadores() {
  const contadores = document.querySelectorAll('[data-mt-contador]');
  if (!contadores.length) return;

  const reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const anima = (el) => {
    const hasta = parseFloat(el.dataset.hasta || '0');
    const sufijo = el.dataset.sufijo || '';
    if (reducirMovimiento) {
      el.textContent = hasta + sufijo;
      return;
    }
    const duracion = 1400;
    const inicio = performance.now();
    function paso(ahora) {
      const progreso = Math.min((ahora - inicio) / duracion, 1);
      const facilitado = 1 - Math.pow(1 - progreso, 3);
      const valor = Math.round(hasta * facilitado);
      el.textContent = valor + sufijo;
      if (progreso < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          anima(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.6 }
  );

  contadores.forEach((el) => observer.observe(el));
}

/* Galería de la página de producto: clic en miniatura cambia la imagen principal */
function initGaleriaProducto() {
  const galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;

  const principal = galeria.querySelector('[data-mt-imagen-principal]');
  const miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
  if (!principal || !miniaturas.length) return;

  miniaturas.forEach((miniatura) => {
    miniatura.addEventListener('click', () => {
      const src = miniatura.dataset.mtImagenGrande;
      const alt = miniatura.dataset.mtAlt || '';
      if (!src) return;
      principal.src = src;
      principal.alt = alt;
      miniaturas.forEach((m) => m.classList.remove('is-active'));
      miniatura.classList.add('is-active');
    });
  });
}

/* Modal "Deja tu reseña": abrir/cerrar + selector de estrellas */
function initModalResena() {
  const openBtns = document.querySelectorAll('[data-mt-modal-open]');
  if (!openBtns.length) return;

  openBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const modal = document.getElementById(btn.dataset.mtModalOpen);
      if (modal) modal.classList.add('is-open');
    });
  });

  document.querySelectorAll('[data-mt-modal]').forEach((overlay) => {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) overlay.classList.remove('is-open');
    });
    overlay.querySelectorAll('[data-mt-modal-close]').forEach((btn) => {
      btn.addEventListener('click', () => overlay.classList.remove('is-open'));
    });

    const stars = overlay.querySelectorAll('[data-mt-rate-stars] .mt-rate-star');
    const ratingInput = overlay.querySelector('[data-mt-rate-input]');
    if (stars.length && ratingInput) {
      const marcar = (valor) => {
        stars.forEach((s) => s.classList.toggle('on', Number(s.dataset.valor) <= valor));
      };
      marcar(Number(ratingInput.value) || 5);
      stars.forEach((star) => {
        star.addEventListener('click', () => {
          const valor = Number(star.dataset.valor);
          ratingInput.value = valor;
          marcar(valor);
        });
      });
    }
  });
}

/* Selector de variantes de producto: actualiza precio, id del formulario y estado agotado */
function initVariantesProducto() {
  const contenedor = document.querySelector('[data-mt-variantes]');
  if (!contenedor) return;

  const datosEl = document.querySelector('[data-mt-variantes-json]');
  const selects = contenedor.querySelectorAll('select[data-mt-opcion]');
  const inputId = document.querySelector('[data-mt-input-id]');
  const precioEl = document.querySelector('[data-mt-precio]');
  const precioAntesEl = document.querySelector('[data-mt-precio-antes]');
  const botonEl = document.querySelector('[data-mt-boton-comprar]');
  if (!datosEl || !selects.length || !inputId) return;

  let variantes = [];
  try {
    variantes = JSON.parse(datosEl.textContent);
  } catch (e) {
    return;
  }

  function formatearPrecio(centavos) {
    return (centavos / 100).toLocaleString('es-ES', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' });
  }

  function actualizar() {
    const seleccion = Array.from(selects).map((s) => s.value);
    const variante = variantes.find((v) =>
      v.opciones.every((valor, indice) => valor === seleccion[indice])
    );
    if (!variante) return;

    inputId.value = variante.id;

    if (precioEl) precioEl.textContent = formatearPrecio(variante.precio);
    if (precioAntesEl) {
      if (variante.precioAntes && variante.precioAntes > variante.precio) {
        precioAntesEl.textContent = formatearPrecio(variante.precioAntes);
        precioAntesEl.style.display = '';
      } else {
        precioAntesEl.style.display = 'none';
      }
    }

    if (botonEl) {
      if (variante.disponible) {
        botonEl.disabled = false;
        botonEl.textContent = botonEl.dataset.textoComprar || 'Añadir al carrito';
      } else {
        botonEl.disabled = true;
        botonEl.textContent = botonEl.dataset.textoAgotado || 'Agotado';
      }
    }
  }

  selects.forEach((select) => select.addEventListener('change', actualizar));
  actualizar();
}
